// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
import { mapState } from 'vuex';
import util from '../../../util/utils';
import apiResultValidator from '../../../../../share/src/util/apiResultValidator';

const prodDomain = {
  'ssm.subaru.co.jp': 'https://mirror.ssm.subaru.co.jp',
  'ca.ssm.subaru.co.jp': 'https://mirror-ca.ssm.subaru.co.jp',
  'ssm5.subaru.com': 'https://mirror.ssm5.subaru.com',
  'subscriber.ssm5.subaru.com': 'https://mirror-subscriber.ssm5.subaru.com',
  'gihon.ssm.subaru.co.jp': 'https://mirror-gihon.ssm.subaru.co.jp',
};

export default {
  data() {
    return {
      msg: '',
      siteUrl: '',
      isCloudFront: false,
    };
  },

  watch: {
    language() {
      this.updateLanguage();
    }
  },

  computed: {
    ...mapState({
      isMaintenance: state => state.systems.isMaintenance,
      dateTimeRange: state => state.systems.maintenanceDateTimeRange,
      language: state => state.systems.language
    })
  },

  methods: {

    updateLanguage: function () {
      this.msg = this.$t('error.label_maint_time_title');
      if (this.dateTimeRange.start && this.dateTimeRange.end) {
        const formattedDateTimeRange = this.formatMaintenanceDateTime();
        this.msg += `<br/>${formattedDateTimeRange.start} ${this.$t('error.label_maint_time_range')} ${formattedDateTimeRange.end} `;
      } else {
        this.msg += `<br/>${this.$t('error.label_maint_time_tbd')}`;
      }
    },

    formatMaintenanceDateTime() {
      const startDate = new Date(this.dateTimeRange.start);
      const endDate = new Date(this.dateTimeRange.end);
      const formattedStartDate = util.timeConverter(startDate, null, "day");
      const formattedStartTime = this.formatTimeAmPm(startDate);
      const formattedEndDate = util.timeConverter(endDate, null, "day");
      const formattedEndTime = this.formatTimeAmPm(endDate);
      return { start: `${formattedStartDate} ${formattedStartTime}`, end: `${formattedEndDate} ${formattedEndTime}` };
    },

    formatTimeAmPm(param) {
      let hours = param.getHours();
      const minutes = String(param.getMinutes()).padStart(2, "0");
      const ampm = hours >= 12 ? this.$t('error.label_maint_time_pm') : this.$t('error.label_maint_time_am');
      hours = hours % 12 || 12;
      if (this.language === 'ja' || this.language === 'zh') {
        return `${ampm} ${hours}:${minutes}`;
      }
      return `${hours}:${minutes} ${ampm}`;
    }
  },

  created() {
    this.updateLanguage();

    this.isCloudFront = util.isCloudFrontUrl();
    if (!this.isCloudFront) {
      let domainConfig = prodDomain[window.location.hostname]; // 例）domainConfig = 'https://mirror.ssm.subaru.co.jp'
      if (!domainConfig) {
        domainConfig = `https://mirror-${window.location.hostname}`;
      }
      if (apiResultValidator.init() === 'manage') {
        domainConfig += '/manage/';
      }
      this.siteUrl = domainConfig;
    }

    this.$nextTick(() => {
      //メンテナンス中に専用コマンドを押下した場合はログイン画面に遷移する
      document.onkeydown = event => {
        if (event) {
          // Ctrl+Shift+V key detection
          if (event.shiftKey && event.ctrlKey) {
            if (event.code === "KeyV") {
              // 強制ログインをONに設定 
              this.$emit('forced-login', true);
            }
          }
        }
      };
    });
  },

  beforeUnmount() {
    // onkeydown の再登録
    document.onkeydown = (event) => {
      return util.checkSSM5ValidCharacters(event);
    };
  }
};
